/**
 * @flow
 * @relayHash e3164ed4a8f24b2cbba62aec3148b629
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type JournalEntryStatus = "DRAFT" | "POSTED" | "VOIDED";
export type PostJournalEntryInput = {|
  id: string
|};
export type PostJournalEntryMutationVariables = {|
  input: PostJournalEntryInput
|};
export type PostJournalEntryMutationResponse = {|
  +postJournalEntry: {|
    +journalEntryEdge: {|
      +node: {|
        +id: string,
        +status: JournalEntryStatus,
        +postedAt: ?any,
      |}
    |}
  |}
|};
export type PostJournalEntryMutation = {|
  variables: PostJournalEntryMutationVariables,
  response: PostJournalEntryMutationResponse,
|};
*/


/*
mutation PostJournalEntryMutation(
  $input: PostJournalEntryInput!
) {
  postJournalEntry(input: $input) {
    journalEntryEdge {
      node {
        id
        status
        postedAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PostJournalEntryInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "postJournalEntry",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostJournalEntryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "journalEntryEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "JournalEntryEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "JournalEntry",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "postedAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PostJournalEntryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PostJournalEntryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "PostJournalEntryMutation",
    "id": null,
    "text": "mutation PostJournalEntryMutation(\n  $input: PostJournalEntryInput!\n) {\n  postJournalEntry(input: $input) {\n    journalEntryEdge {\n      node {\n        id\n        status\n        postedAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41cd668c40452590fce16053af6c1bb5';
module.exports = node;
